module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('login', {
    attrs: {
      "showConfirmedAccount": _vm.showConfirmedAccount
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-d70716da", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d70716da"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Confirmation.vue
// module id = 1599
// module chunks = 0